<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Account Settings'|translate}}
          </v-card-title>
          <v-card-text>
              <div v-if="!loading&&activeItem">
              <v-text-field :label="'User Name'|translate" autofocus v-model="activeItem.user_name" disabled></v-text-field>
              <v-text-field :label="'Email'|translate" autofocus v-model="activeItem.email"></v-text-field>
              <v-switch color="success"  v-model="isChangePassword" :label="'Change password?'|translate"></v-switch>
              <v-text-field :label="'Password'|translate" v-model="activeItem.password" :type="'password'" v-if="isChangePassword"></v-text-field>
              </div>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="saveChanges(true)">{{'Save'|translate}}</v-btn>
              <v-btn @click="initializeVar(true)">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putCurrentUser, getCurrentUser} from '../../helper'
  import { mapGetters } from 'vuex'

  export default {
    components: { },
    props: {
      value: {type:Boolean, default: true},
      item: {type: String, default: null},
    },
      computed: {
          ...mapGetters([
              'managedFacilities',
          ]),
      },
    watch: {
      item (item) {
          let me=this
        this.initializeVar()
        if (item){
            me.loading=true
            getCurrentUser().then(function(response){
                me.activeItem=response.user
                me.loading=false
            })

          //this.activeItem = this.item
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        isChangePassword: false,
          loading:true,
        dialog: false,
          roles:[
              {
                  text:this.$options.filters.translate('Administrator'),
                  value:'admin'
              },
              {
                  text:this.$options.filters.translate('Maintainer'),
                  value:'maintainer'
              },
              {
                  text:this.$options.filters.translate('Operator'),
                  value:'operator'
              },
              {
                  text:this.$options.filters.translate('Viewer'),
                  value:'viewer'
              }
          ],
          activeItem: null
      }
    },
    methods: {
      initializeVar(close) {
          if(close) {
              this.dialog = false;
          }
      },
      async saveChanges (close) {
        await putCurrentUser(
          {
            'email': this.activeItem.email,
            'user_name': this.activeItem.user_name,
            'password': (this.isChangePassword)?this.activeItem.password:'',
          }
        )
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'UserProfileDialog'
  }
</script>

<style scoped>

</style>
